import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import Features from '../components/Features'
import HeaderDownSection from '../components/HeaderDownSection'

function Contact() {
  return (
    <div>
      <Navbar />
      <Features />
      <HeaderDownSection />
      <Footer />
    </div>
  )
}

export default Contact
